<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar o fertilizante <b>{{this.entry.description}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(fertilizer) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_FERTILIZER_MUTATION,
          variables: {
            id: fertilizer.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyFertilizer.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_FERTILIZER_MUTATION = gql `
  mutation($id: ID!) {
    destroyFertilizer(id: $id) {
      item {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>